// lib
import React from 'react';
import { Helmet } from 'react-helmet-async';
//def
interface MetaInfoProps {
  metaTitle?: string;
  metaDescription?: string;
  metaKeywords?: string;
  canonical?: string;
}

function View({
  metaTitle = '',
  metaDescription = '',
  metaKeywords = '',
  canonical = '',
}: MetaInfoProps) {
  return (
    <Helmet>
      <title>{metaTitle}</title>
      {metaDescription && <meta name="description" content={metaDescription} />}
      {metaKeywords && <meta name="keywords" content={metaKeywords} />}
      {canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  );
}

export default View;
